import * as React from 'react';

import { DetailsTooltipStyles } from '../../CardView/DetailsTooltipStyles';
import { EntityLink, EntityLinkProps } from './EntityLink';


export interface RelatedEntityListProps {
  label: string;
  list: EntityLinkProps[];
}

export function RelatedEntityList(props: RelatedEntityListProps) {
  return props.list && props.list.length > 0 && (
    <div className={DetailsTooltipStyles.MetadataSection} style={{display: 'flex', flexDirection: 'row'}}>
      <div className={DetailsTooltipStyles.MetadataRelatedTitle} style={{flexGrow: 0}}>{props.label}</div>
      <div className={DetailsTooltipStyles.MetadataRelatedList}>
        { props.list.map((link, index) =>
          <EntityLink {...link} key={`related-entity-${index}`} />
        )}
      </div>
    </div>
  );
}
